import { motion } from "framer-motion";
import { SocialLink } from "../data/socialTags";
import { itemUp } from "../Utils/framerMotionVariants";

const SocialTag: React.FC<{ socialLink: SocialLink }> = ({ socialLink }) => {
  return (
    <motion.a
      variants={itemUp}
      key={socialLink.name}
      href={socialLink.href}
      className="text-sm px-3 py-2 rounded-md border border-white/20 hover:border-cyan-400 hover:shadow-lg transition"
      target="_blank"
      rel="noreferrer"
    >
      {socialLink.name}
    </motion.a>
  );
};

export default SocialTag;
